const assesClient = {
  assesUrl: "/assessment/names",
  scores: "/assessment/scores",
  recommendation: "/assessment/recommendation",
};

export default assesClient;
